import { Injectable } from "@angular/core";
import { FitApiClientService, FitList } from "@shared/fit-api-client.service";
import { ProgramDetails, TrainingDetails, TrainingSummary, UserActivityType, UserTrainingActivityListItem } from "./types";

@Injectable({ providedIn: 'root' })

export class UserActivityService {
    constructor(private fitApi: FitApiClientService) { }

    public search(query?: string, page?: number) {
        const params: any = {
            search: query,
            page: page.toString()
        };

        return this.fitApi.get<FitList<UserTrainingActivityListItem>>('/admin/user-training-activity', params);
    }

    public getTrainingSummary(id: number) {
        return this.fitApi.get<TrainingSummary>('/admin/user-training-activity/' + id);
    }

    public getTrainingDetails(id: number) {
        return this.fitApi.get<TrainingDetails>('/admin/user-training-activity/' + id + '/details');
    }

    public getProgramDetails(id: number) {
        return this.fitApi.get<ProgramDetails>('/admin/user-program-activity/' + id + '/details');
    }

    public createNote(id: number, type: UserActivityType, note: string, noteId?: number) {
        const params = {
            object_id: id,
            object_type: type === 'training' ? 'App\\Models\\UserTrainingActivity' : 'App\\Models\\UserProgramActivity',
            note_content: note
        };

        return this.fitApi.put<any>('/admin/note/' + (noteId || 0), params);
    }

    public deleteNote(noteId: number) {
        return this.fitApi.delete<any>('/admin/note/' + noteId);
    }
}
